import $ from 'jquery';
import setupFacebookShareLink from './setupFacebookShareLink';
import setupTwitterShareLink from './setupTwitterShareLink';
/* import setupGoogleShareLink from './setupGoogleShareLink'; */

const enableSocialButtons = () => {
	/**
	 * show / hide social meida buttons
	 */
	$('.social-button > .item.-share').on('click', () => {
		$('.social-button').toggleClass('-show');
	});

	/**
	 * Facebook Share
	 */
	setupFacebookShareLink(
		document.querySelector('.social-button > .item.fa-facebook'),
	);

	/**
	 * Twitter Share
	 */
	setupTwitterShareLink(
		document.querySelector('.social-button > .item.fa-twitter'),
	);

	/**
	 * Google Plus Share
	 */
	// setupGoogleShareLink(
	// 	document.querySelector('.social-button > .item.fa-google-plus'),
	// );
};

export default enableSocialButtons;



// WEBPACK FOOTER //
// ./src/js/common/enableSocialButtons.js